/* Responsibility: Show banners on pages that do not need refresh capabilities. */
import isEqual from 'deep-equal';
import AppNexus from 'shared/banners/appNexus/appNexus.js';
import Server from 'shared/lib/modules/server.js';

import loadAppNexus from 'shared/banners/appNexus/loadAppNexus.js';

loadAppNexus();

const createAppnexus = function () {
    return new AppNexus({
        server: new Server(window.FINN.travel.banner.url),
        apntag: window.apntag,
        isEqual,
        _window: window,
    });
};

window.showFinnTravelBanners = function () {
    if (!window.finnTravelAppNexus) {
        window.finnTravelAppNexus = createAppnexus();
    }
    window.finnTravelAppNexus.showBanners(
        document.querySelectorAll('[data-horseshoe-banner]'),
        { location: window.FINN.travel.banner.location });
};



// WEBPACK FOOTER //
// /mnt/build-dir/TRAVELAPP-FRONTPAGEDEPLOY-FRONTPAGEPIPELINE/shared/overlay/src/main/webapp/scripts/banners/appNexus/runAppNexusCarTrawler.js